// import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";

// const Card2 = () => {
//   return (
//     <section
//       className="d-flex align-items-center"
//       style={{
//         backgroundColor: "#DADEE1",
//         padding: "60px 0px 60px 30px", // remove right padding
//         position: "relative",
//         overflow: "hidden",
//           minHeight: "500px",
//       }}
//     >
//       {/* Left Text Section */}
//       <div style={{ maxWidth: "500px", zIndex: 2 ,  marginLeft: "80px",}}>
//         <p className="text-muted mb-2">Culinary Essentials</p>
//         <h1 style={{ fontWeight: "bold", fontSize: "2.5rem" }}>
//           Spices that Inspire
//         </h1>
//         <p className="text-secondary mb-4">
//           From the finest farms to your kitchen, our spices bring authentic
//           flavors, rich aromas, and the essence of tradition to every recipe you
//           create.
//         </p>
//         <button
//           className="btn btn-dark"
//           style={{ borderRadius: "30px", padding: "10px 25px" }}
//         >
//           Explore
//         </button>
//       </div>

//       {/* Right Image Section */}
//       <div
//         style={{
//           position: "absolute",
//           right: 0,
//           bottom: 0,
//           top: 0,
//           display: "flex",
//           alignItems: "center",
//         }}
//       >
//         <img
//           src="https://palmtreeshopping.com/cdn/shop/files/WhatsApp_Image_2024-12-27_at_5.02.36_PM.jpg?v=1735299275&width=840"
//           alt="Spices"
//           style={{
//             height: "100%",
//             objectFit: "cover",
//           }}
//         />
//       </div>
//     </section>
//   );
// };

// export default Card2;
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const Card2 = () => {
  return (
    <section
      className="d-flex flex-column flex-md-row align-items-center"
      style={{
        backgroundColor: "#DADEE1",
        padding: "60px 30px",
        position: "relative",
        overflow: "hidden",
        minHeight: "500px",
      }}
    >
      {/* Left Text Section */}
      <div
        style={{
          maxWidth: "500px",
          zIndex: 2,
          marginLeft: "20px",
        }}
        className="text-center text-md-start"
      >
        <p className="text-muted mb-2">Culinary Essentials</p>
        <h1 style={{ fontWeight: "bold", fontSize: "2rem" }}>
          Spices that Inspire
        </h1>
        <p className="text-secondary mb-4">
          From the finest farms to your kitchen, our spices bring authentic
          flavors, rich aromas, and the essence of tradition to every recipe you
          create.
        </p>
        <button
          className="btn btn-dark"
          style={{ borderRadius: "30px", padding: "10px 25px" }}
        >
          Explore
        </button>
      </div>

      {/* Right Image Section */}
      <div
        style={{
          position: "absolute",
          right: 0,
          bottom: 0,
          top: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          width: "100%",
        }}
      >
        <img
          src="https://palmtreeshopping.com/cdn/shop/files/WhatsApp_Image_2024-12-27_at_5.02.36_PM.jpg?v=1735299275&width=840"
          alt="Spices"
          style={{
            height: "100%",
            objectFit: "cover",
            maxWidth: "100%",
          }}
        />
      </div>

      {/* Mobile Overlay (dim the image so text is visible) */}
      <div
        className="d-md-none"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(218,222,225,0.6)",
          zIndex: 1,
        }}
      ></div>
    </section>
  );
};

export default Card2;
